var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":'purchase-order-list'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }